import React from "react";
import { FiArrowUpRight } from "react-icons/fi";

export default function Banner() {
  return (
    <div className="mt animate__delay-2s">
      <h1 className="display-5 fw-bolder mb-2">
        We develop awesome{" "}
        <strong>
          <i className="text-warning">frontend.</i>
        </strong>{" "}
      </h1>
      <div className="d-flex align-items-center mt-3">
        <a
          href="https://www.behance.net/codeindica"
          target="_blank"
          className="d-flex"
          rel="noreferrer"
        >
          <h4>Behance</h4>
          <FiArrowUpRight />
        </a>
        <a
          href="https://www.paypal.com/paypalme/jamesSudhirKr"
          className="mx-5 d-flex"
          target="_blank"
          rel="noreferrer"
        >
          <h4>Paypal</h4>
          <FiArrowUpRight />
        </a>
      </div>

      <div className="mt" />
      <div>
        <div className="list">
          <span className="sm">Designing Skills</span>
          <p className="m-0">
            Figma, UI-UX, Wireframing, Mockups, Branding, Templates
          </p>
        </div>
        <div className="list">
          <span className="sm">Technical Skills</span>
          <p className="m-0">React, React Native, HTML, CSS, JavaScript</p>
        </div>

        <div className="list">
          <span className="sm">Languages</span>
          <p className="m-0">English, Hindi</p>
        </div>
        <div className="list">
          <span className="sm">Education</span>
          <p className="m-0">Master of Computer Application</p>
        </div>
      </div>
    </div>
  );
}
